import featuredPlayersBg from '../../assets/profile_preview_bg.png';
import playerAppLogo from '../../assets/PlayerAppLogoGreen.png';
import { BigButtons } from '../../components/reusable/buttons/Buttons';
import { useEffect, useState } from 'react';

const PopupPlaceholder = ({ type }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 100);
        return () => clearTimeout(timer);
    }, []);

    const onLoginClick = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const params = urlParams.toString();
        const from = window.location.pathname + (params ? '?' + params : '');
        window.location.href = `/login?from=${encodeURIComponent(from)}`;
    };

    const onPlayerSignupClick = () => {
        window.open('https://join.playerapp.co', '_blank');
    };

    const onNonPlayerSignupClick = () => {
        window.open('https://join.playerapp.co/recruit', '_blank');
    };

    return (
        <div
            className='min-h-screen w-full bg-cover bg-center bg-no-repeat'
            style={{
                backgroundImage: `url(${featuredPlayersBg})`
            }}
        >
            <div
                className={`container mx-auto absolute top-48 flex flex-col gap-6 transition-all duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}
            >
                <img
                    src={playerAppLogo}
                    alt='Player App Logo'
                    className={`w-[140px] h-[140px] mx-auto transition-all duration-1000 ease-out ${isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}
                    style={{ transitionDelay: '200ms' }}
                />

                <h1
                    className={`px-4 text-[20px] leading-[28px] font-bold text-white text-center transition-all duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}
                    style={{ transitionDelay: '400ms' }}
                >
                    {type === 'profile' ? 'This profile' : 'This feature'} is
                    only available <br />
                    to PLAYER users
                </h1>

                <div
                    className={`flex flex-col gap-8 pb-10 pt-6 transition-all duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'}`}
                    style={{ transitionDelay: '600ms' }}
                >
                    <BigButtons
                        green={true}
                        label='Log in'
                        onClick={onLoginClick}
                    />
                    <p
                        className='text-white text-center text-[14px] transition-all duration-500 ease-out'
                        style={{ transitionDelay: '800ms' }}
                    >
                        New to PLAYER? Sign up below.
                    </p>
                    <div
                        className='flex flex-col gap-3 transition-all duration-500 ease-out'
                        style={{ transitionDelay: '1000ms' }}
                    >
                        <BigButtons
                            white={true}
                            label='PLAYERS'
                            onClick={onPlayerSignupClick}
                        />
                        <BigButtons
                            white={true}
                            label='AGENTS, SCOUTS, COACHES'
                            onClick={onNonPlayerSignupClick}
                        />
                    </div>
                </div>

                <div className='flex justify-center items-center gap-10'>
                    <a
                        href='https://join.playerapp.co/tcs'
                        target='_blank'
                        className='text-white text-[10px] underline'
                    >
                        Terms & Conditions
                    </a>
                    <a
                        href='https://join.playerapp.co/privacypolicy'
                        target='_blank'
                        className='text-white text-[10px] underline'
                    >
                        Privacy Policy
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PopupPlaceholder;
